import axios from "@/libs/api.request.js";
import { WX_URL, IS_YW, IS_PRE } from "@/config";
import { sort_ASCII1 } from "@/libs/utils";

export const getEnv = () => { 
  if (IS_YW) {
    if (IS_PRE) {
      return "//h5-pre.yuwanc.com/wechat";
    } else {
      return "//h5.yuwanc.com/wechat";
    }
  }
  switch (window.location.hostname) {
    case "wxhdtest.hzwxbz999.cn":
      return "//h5test.hzwxbz999.cn/wechat";
    case "wxhdpre.hzwxbz999.cn":
      return "//h5.hzwxbz999.cn/wechat";
    default:
      return "//h5.hzwxbz3.cn/wechat";
  }
};

// 获取OPEN ID/用户接口
export const getUser = (params) =>
  axios.request({ url: `${getEnv()}/game-bind/user`, params, method: "get" });

// 绑定接口
export const bind = (data) =>
  axios.request({ url: `${getEnv()}/game-bind`, data });

// 发送验证码
export const sendCode = (data) =>
  axios.request({
    baseURL: IS_YW ? "//h5.yuwanc.com" : "//h5.hzwxbz3.cn",
    url: "/user/sms/code",
    data,
  });

// 获取下载链接
export const getURL = (params) =>
  axios.request({ url: `${getEnv()}/game-bind/url`, params, method: "get" });

// 获取微信签名接口
export const wechatSign = (data) =>
  axios.request({ baseURL: WX_URL, url: "/api/get_wechat_sign", data });

// 绑定公众号
export const oaBind = (data) =>
  axios.request({ url: `${getEnv()}/app/oa-bind`, data });

// 获取vip切用户详情
export const vipUserDetails = (params) =>
  axios.request({
    url: `${getEnv()}/change/url/record`,
    params,
    method: "get",
  });

export const getSyEnv = () => {
  if (IS_YW) {
    if (IS_PRE) {
      return "//h5-pre.yuwanc.com";
    } else {
      return "//h5.yuwanc.com";
    }
  }
  // 处理本地开发环境
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname.includes('127.0.0.1') || hostname.includes('172.16.') || hostname.includes('192.168.')) {
    return "//h5test.hzwxbz999.cn"; // 本地开发默认使用测试环境
  }
  
  switch (hostname) {
    case "wxhdtest.hzwxbz999.cn":
      return "//h5test.hzwxbz999.cn";
    case "wxhdpre.hzwxbz999.cn":
      return "//h5.hzwxbz999.cn";
    default:
      return "//h5.hzwxbz3.cn";
  }
};

// 获取硬核渠道包切用户详情
export const thirdUserDetails = (data) =>
  axios.request({
    url: `${getSyEnv()}/third-channel/change-url-record`,
    data,
    method: "post",
  });

// 通过credentials获取用户信息
export const getUserByCredentials = (data) =>
  axios.request({
    url: `${getSyEnv()}/activity/authorize/credential`,
    data: {
      sign: sort_ASCII1(data),
      ...data,
    },
    unHint: true,
  });

// 获取企微单人单码接口
export const getQWCode = (data) =>
  axios.request({
    url: `${getSyEnv()}/qy-weixin/activity-contact-icon-info`,
    data: {
      sign: sort_ASCII1(data),
      ...data,
    },
  });

// 获取直播引流企微二维码
export const getLiveQWCode = (data) =>
  axios.request({
    url: `${getSyEnv()}/qy-weixin/stream-contact-icon-info`,
    data: {
      sign: sort_ASCII1(data),
      ...data,
    },
  });

export const eventTrackExtra = (data) =>
  axios.request({
    url: `${getSyEnv()}/noncore/event-track/extra`,
    data,
    unHint: true,
  });

const getDoudianWechatCdkHost = (platform) => {
  const hostname = window.location.hostname;
  const isPre = hostname === "wxhdpre.hzwxbz999.cn";
  const isProd = hostname === "wxhd.hzwxbz2.cn";
  if (platform === "yuewan") {
    if (isProd) return "https://h5.w2you.com";
    if (isPre) return "https://h5-pre.w2you.com";
    return "https://h5-test.xdi2.cn";
  }
  if (isProd) return "https://h5.hzwxbz3.cn";
  if (isPre) return "https://h5.hzwxbz999.cn";
  return "https://h5test.hzwxbz999.cn";
};

export const getDoudianWechatCdk = ({ session, platform }) =>
  axios.request({
    url: `${getDoudianWechatCdkHost(platform)}/third-api/doudian/wechat-cdk/session`,
    params: { session, platform },
    method: "get",
    unHint: true,
  });

// 获取企微通码信息
export const getQWCommonInfo = (data) =>
  axios.request({
    url: `${getSyEnv()}/qy-weixin/general-code-info`,
    data: {
      ...data,
      sign: sort_ASCII1(data),
    },
  });

// 获取抖音企微通码信息
export const getDouyinQWCommonInfo = (data) =>
  axios.request({
    url: `${getSyEnv()}/qy-weixin/tiktok-contact-icon-info`,
    data: {
      ...data,
      sign: sort_ASCII1(data),
    },
  });

// 获取企微通码绑定页信息
export const getQWBindingInfo = (data) =>
  axios.request({
    url: `${getSyEnv()}/qy-weixin/general-bind-info`,
    data: {
      ...data,
      sign: sort_ASCII1(data),
    },
  });

// 企微通码绑定
export const qwBinding = (data) =>
  axios.request({
    url: `${getSyEnv()}/qy-weixin/general-bind`,
    timeout: 15000,
    unHint: true,
    data: {
      ...data,
      sign: sort_ASCII1(data),
    },
  });

// 获取企微通码角色选择列表
export const getQWRoleList = (data) =>
  axios.request({
    url: `${getSyEnv()}/qy-weixin/general-role-list`,
    timeout: 15000,
    unHint: true,
    data: {
      ...data,
      sign: sort_ASCII1(data),
    },
  });

// VIP客服 - 登录页初始信息
export const getVipInitial = (data) =>
  axios.request({
    url: `${getSyEnv()}/vip-qy-weixin/initial`,
    data: {
      ...data,
      sign: sort_ASCII1(data),
    },
  });

// VIP客服 - 获取游戏选项
export const getVipGameOptions = (data) =>
  axios.request({
    url: `${getSyEnv()}/vip-qy-weixin/game-options`,
    data: {
      ...data,
      sign: sort_ASCII1(data),
    },
  });

// VIP客服 - 匹配客服
export const findVipCustomer = (data) =>
  axios.request({
    url: `${getSyEnv()}/vip-qy-weixin/find-customer`,
    data: {
      ...data,
      sign: sort_ASCII1(data),
    },
  });


